import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CONSTS } from 'constants/index.js';

const locales = {
  af_ZA: 'Afrikaans',
  sq_AL: 'Albanian',
  ar_AR: 'Arabic',
  hy_AM: 'Armenian',
  ay_BO: 'Aymara',
  az_AZ: 'Azeri',
  eu_ES: 'Basque',
  be_BY: 'Belarusian',
  bn_IN: 'Bengali',
  bs_BA: 'Bosnian',
  bg_BG: 'Bulgarian',
  ca_ES: 'Catalan',
  ck_US: 'Cherokee',
  hr_HR: 'Croatian',
  cs_CZ: 'Czech',
  da_DK: 'Danish',
  nl_NL: 'Dutch',
  nl_BE: 'Dutch',
  en_PI: 'English (Pirate)',
  en_GB: 'English (UK)',
  en_UD: 'English (Upside Down)',
  en_US: 'English (US)',
  eo_EO: 'Esperanto',
  et_EE: 'Estonian',
  fo_FO: 'Faroese',
  tl_PH: 'Filipino',
  fi_FI: 'Finnish',
  fb_FI: 'Finnish',
  fr_CA: 'French (Canada)',
  fr_FR: 'French (France)',
  gl_ES: 'Galician',
  ka_GE: 'Georgian',
  de_DE: 'German',
  el_GR: 'Greek',
  gn_PY: 'Guaran',
  gu_IN: 'Gujarati',
  he_IL: 'Hebrew',
  hi_IN: 'Hindi',
  hu_HU: 'Hungarian',
  is_IS: 'Icelandic',
  id_ID: 'Indonesian',
  ga_IE: 'Irish',
  it_IT: 'Italian',
  ja_JP: 'Japanese',
  jv_ID: 'Javanese',
  kn_IN: 'Kannada',
  kk_KZ: 'Kazakh',
  km_KH: 'Khmer',
  tl_ST: 'Klingon',
  ko_KR: 'Korean',
  ku_TR: 'Kurdish',
  la_VA: 'Latin',
  lv_LV: 'Latvian',
  fb_LT: 'Leet Speak',
  li_NL: 'Limburgish',
  lt_LT: 'Lithuanian',
  mk_MK: 'Macedonian',
  mg_MG: 'Malagasy',
  ms_MY: 'Malay',
  ml_IN: 'Malayalam',
  mt_MT: 'Maltese',
  mr_IN: 'Marathi',
  mn_MN: 'Mongolian',
  ne_NP: 'Nepali',
  se_NO: 'Northern S?mi',
  nb_NO: 'Norwegian (bokmal)',
  nn_NO: 'Norwegian (nynorsk)',
  ps_AF: 'Pashto',
  fa_IR: 'Persian',
  pl_PL: 'Polish',
  pt_BR: 'Portuguese (Brazil)',
  pt_PT: 'Portuguese (Portugal)',
  pa_IN: 'Punjabi',
  qu_PE: 'Quechua',
  ro_RO: 'Romanian',
  rm_CH: 'Romansh',
  ru_RU: 'Russian',
  sa_IN: 'Sanskrit',
  sr_RS: 'Serbian',
  zh_CN: 'Simplified Chinese (China)',
  sk_SK: 'Slovak',
  sl_SI: 'Slovenian',
  so_SO: 'Somali',
  es_LA: 'Spanish',
  es_CL: 'Spanish (Chile)',
  es_CO: 'Spanish (Colombia)',
  es_MX: 'Spanish (Mexico)',
  es_ES: 'Spanish (Spain)',
  es_VE: 'Spanish (Venezuela)',
  sw_KE: 'Swahili',
  sv_SE: 'Swedish',
  sy_SY: 'Syriac',
  tg_TJ: 'Tajik',
  ta_IN: 'Tamil',
  tt_RU: 'Tatar',
  te_IN: 'Telugu',
  th_TH: 'Thai',
  zh_HK: 'Traditional Chinese (Hong Kong)',
  zh_TW: 'Traditional Chinese (Taiwan)',
  tr_TR: 'Turkish',
  uk_UA: 'Ukrainian',
  ur_PK: 'Urdu',
  uz_UZ: 'Uzbek',
  vi_VN: 'Vietnamese',
  cy_GB: 'Welsh',
  xh_ZA: 'Xhosa',
  yi_DE: 'Yiddish',
  zu_ZA: 'Zulu',
};

class LocaleInfo extends Component {
  render() {
    const style = Object.assign({}, this.props.style);
    const friendlyName =
      locales[this.props.locale] ||
      CONSTS.LANGUAGES[this.props.locale] ||
      this.props.locale;
    return (
      <p style={style} className="system-details">
        <span className="system-details-label col-4 p-0">Language:{' '}</span>
        <span className="system-details-value"> {friendlyName}</span>
      </p>
    );
  }
}

LocaleInfo.defaultProps = {
  locale: 'unknown',
  style: {},
};

LocaleInfo.propTypes = {
  locale: PropTypes.string,
  style: PropTypes.object,
};

export default LocaleInfo;
